import { call, delay, put, takeLatest } from 'redux-saga/effects';
import { actions } from './slice';
import staffApis from './apis';
import { ISagaFunc } from 'services/actionConfigs';
import { GetStaffListParams } from './constants';

const getStaffList: ISagaFunc<GetStaffListParams> = function* ({ payload }) {
  yield delay(200);
  try {
    const response = yield call(staffApis.staff.getList, payload);
    yield put(actions.async.getStaffList.success(response.data.data));
  } catch (error) {
    yield put(actions.async.getStaffList.fail({}));
  }
};

const getStaffDetail: ISagaFunc<string> = function* ({ payload }) {
  yield delay(200);
  try {
    const response = yield call(staffApis.staff.getDetail, payload);
    yield put(actions.async.getStaffDetail.success(response.data.data));
  } catch (error) {
    yield put(actions.async.getStaffDetail.fail({}));
  }
};

export default function* sagas() {
  yield takeLatest(actions.async.getStaffList.fetch, getStaffList);
  yield takeLatest(actions.async.getStaffDetail.fetch, getStaffDetail);
}
